import React from "react";
import { OfferLink } from "./OfferLink";
import { CtaMicrocopy } from "./CtaMicrocopy";
import { CollectionMockup } from "./CollectionMockup";
import { ctaMicrocopy, productVisuals } from "../data/offer";
import { heroBenefits } from "../data/landing";
export function Hero() {
  return <section className="bg-canvas" data-id="element-112" data-mp="4lyxkshw2qgt">
      <div className="mx-auto grid max-w-6xl gap-x-12 px-5 pb-16 pt-10 md:pt-14 lg:grid-cols-[1.05fr_1fr] lg:pb-24 lg:pt-16" data-id="element-113" data-mp="4n1kyqg06arz">
        <div className="text-center lg:col-start-1 lg:text-left" data-id="element-114" data-mp="127efjh2kpvf1">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-gold-deep md:text-[13px]" data-id="element-115" data-mp="xbfht2vcv11y">
            For Christian Parents of Kids Ages 8–14
          </p>
          <h1 className="mt-4 font-display text-[2.1rem] font-extrabold leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-[3.35rem]" data-id="element-116" data-mp="nczqozwbvrsg">
            Build an <span className="text-royal" data-id="element-117" data-mp="3czfny6wb6l9q">Unshakable</span> Foundation of Faith in Your Child Before It's Too Late.
          </h1>
        </div>

        <div className="mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0 lg:self-center" data-id="element-118" data-mp="3j89618jhw3nf">
          <CollectionMockup src={productVisuals.heroMockup} data-id="element-119" data-mp="3o7vj9hzbpjw8" />
        </div>

        <div className="mt-8 text-center lg:col-start-1 lg:mt-6 lg:text-left" data-id="element-120" data-mp="39acuwgqk58pb">
          <p className="text-lg leading-relaxed text-ink-soft" data-id="element-121" data-mp="39cpcutwbfj2d">
            Your child may know every Bible story, memorize Scripture, and attend Sunday School every week.
          </p>
          <p className="mt-2 text-lg font-semibold leading-relaxed text-ink" data-id="element-122" data-mp="30gq5d8cy11ok">
            But will they know <span className="text-royal" data-id="element-123" data-mp="35a2h4hwixdzw">WHY</span> they believe when someone challenges their faith?
          </p>
          <p className="mt-4 leading-relaxed text-ink-soft" data-id="element-124" data-mp="2qi0kr7tnx34m">
            Discover <strong className="font-bold text-ink" data-id="element-125" data-mp="2vjg5szvub9n0">WHY WE BELIEVE</strong> — a complete digital collection
            designed to help children explore the reasons behind Christian faith, understand difficult questions, and
            learn to think, not just repeat.
          </p>

          <p className="mt-6 rounded-2xl bg-gold-light px-5 py-3.5 font-display text-base font-bold text-navy md:text-lg" data-id="element-126" data-mp="s333380kgeuw">
            Real Questions. Meaningful Reasons. A Stronger Foundation for Faith.
          </p>

          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 font-display text-sm font-bold text-navy lg:justify-start" data-id="element-127" data-mp="icrmolzp4d74">
            {heroBenefits.map((item, i) => <li key={item} className="flex items-center gap-3" data-id="element-128" data-mp="1azuhp455y5sm" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" className="text-gold-deep" data-id="element-129" data-mp="161b0fh1ili6l">•</span>}
                {item}
              </li>)}
          </ul>

          <div className="mt-7 max-w-lg lg:max-w-md mx-auto lg:mx-0" data-id="element-130" data-mp="11150zep06rdy">
            <OfferLink label="Yes! I Want Instant Access" data-id="element-131" data-mp="x1w8se9m31ki" />
            <CtaMicrocopy items={ctaMicrocopy.hero} align="start" data-id="element-132" data-mp="x3h1rzga2cg9" />
          </div>
        </div>
      </div>
    </section>;
}